import {commitHovercardPath} from '@github-ui/paths'

import {
  type BaseHovercardOptions,
  type HovercardAttributesResult,
  buildHovercardAttributes,
  useHovercardAttributesBase,
} from './shared'

export type CommitHovercardOptions = BaseHovercardOptions & {
  owner: string | undefined
  repo: string | undefined
  commitish: string | undefined
}

/**
 * Generate hovercard attributes for a commit.
 */
function commitHovercardAttributes(options: CommitHovercardOptions): HovercardAttributesResult {
  if (!options.owner || !options.repo || !options.commitish) return {}

  const url = commitHovercardPath({owner: options.owner, repo: options.repo, commitish: options.commitish})
  return buildHovercardAttributes(url, 'commit', options.tracking ?? true)
}

/**
 * React hook for commit hovercard attributes.
 *
 * @example
 * ```tsx
 * function CommitLink({ owner, repo, commitish }: Props) {
 *   const hovercardAttrs = useHovercardAttributesForCommit({owner, repo, commitish})
 *   return <a href={`/${owner}/${repo}/commit/${commitish}`} {...hovercardAttrs}>{commitish.slice(0, 7)}</a>
 * }
 * ```
 */
export function useHovercardAttributesForCommit(options: CommitHovercardOptions): HovercardAttributesResult {
  return useHovercardAttributesBase(commitHovercardAttributes(options))
}
